// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__Ux9Cj","inputDescription":"styles_inputDescription__2b2Kb"};